import http, { url } from '../../http'

const API_URL = "resource_allocation"

class sgsstResourcesAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

/*   async getAll() {
    const response = await http(`${API_URL}`)
    return response
  }  */

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}&search=${search}`)
    return response
  } 
 
  async get(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  // Modelo nuevo: la app genera el PDF y lo firma el encargado (no se sube el Excel lleno)
  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

}

export default new sgsstResourcesAPI()